// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemoLayout-module__root--QP_eL {
    height: 100%;
    width: 100%;
    position: relative;
}

.DemoLayout-module__canvasContainer--TTBDD {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.DemoLayout-module__uiContainer--fB2Sp {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    margin: var(--app-offset-top) var(--app-offset-right) var(--app-offset-bottom)
        var(--app-offset-left);
}

.DemoLayout-module__uiContainer--fB2Sp > * {
    pointer-events: auto;
}

.DemoLayout-module__visibleCanvasArea--n_z8F {
    position: absolute;
    top: 0;
    left: 0;
    width: var(--grid-width-8);
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/DemoLayout.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,oBAAoB;IACpB;8BAC0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,0BAA0B;AAC9B","sourcesContent":[".root {\n    height: 100%;\n    width: 100%;\n    position: relative;\n}\n\n.canvasContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.uiContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n    margin: var(--app-offset-top) var(--app-offset-right) var(--app-offset-bottom)\n        var(--app-offset-left);\n}\n\n.uiContainer > * {\n    pointer-events: auto;\n}\n\n.visibleCanvasArea {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: var(--grid-width-8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DemoLayout-module__root--QP_eL`,
	"canvasContainer": `DemoLayout-module__canvasContainer--TTBDD`,
	"uiContainer": `DemoLayout-module__uiContainer--fB2Sp`,
	"visibleCanvasArea": `DemoLayout-module__visibleCanvasArea--n_z8F`
};
export default ___CSS_LOADER_EXPORT___;
